require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./videos-ellis-whittam-azure-portal-and-devops-case-study-video.json") })
        }
      }, "path---videos-ellis-whittam-azure-portal-and-devops-case-study-video");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---videos-ellis-whittam-azure-portal-and-devops-case-study-video!./.cache/json/videos-ellis-whittam-azure-portal-and-devops-case-study-video.json
// module id = 952
// module chunks = 231608221292675